<template>
  <div class="container-xl">
  <metainfo></metainfo>
  <template v-if="isForbiddenPage()">
    <NoPermission />
  </template>
  <template v-else>
    <div class="page-header d-print-none">
      <Alert :payload="{
          new_cnt: counted.newCnt,
          delete_cnt: counted.deleteCnt,
      }"/>
      <div class="row g-2 align-items-center">
        <div class="col-sm">
          <Title :payload="{
            title: 'Отмененные',
          }"/>
        </div>
      </div>
    </div>
    <div class="page-body">
      <div class="mb-3">
        <CouponFilter @onFilter="onFilter" :params="getParams()" />
      </div>
      <div ref="scrollComponent">
        <CouponListCancel
          :query="getQuery()"
          @onRender="onRender"
          :clear-result="getClearResult()"
        />
      </div>
    </div>
  </template>
  </div>
</template>

<script>
import {defineComponent, onMounted, onUnmounted, reactive, ref} from 'vue'
import {useMeta} from "vue-meta"
import Helper from "@/services/Helper"
import Permission from "@/modules/users/services/Permission"
import NoPermission from "@/modules/auth/pages/no_permission/Index"
import CouponFilter from "@/modules/promocodes/pages/coupons/components/filter_coupon/Index"
import CouponListCancel from "@/modules/promocodes/pages/coupons/components/list_coupon_cancel/Index"
import Alert from "@/modules/promocodes/components/alert/Index"
import Api from "@/modules/promocodes/pages/shops/services/Api"
import Title from "@/modules/promocodes/components/title/Index.vue"

export default defineComponent({
  name: "ListCouponCancel",
  components: {
    Title,
    Alert,
    NoPermission,
    CouponFilter,
    CouponListCancel,
  },
  setup() {
    useMeta({title: "Отмененные промокоды"})

    let counted = reactive({
      newCnt: 0,
      deleteCnt: 0,
    })

    const scrollComponent = ref(null)

    let query = ref({})
    let clearResult = ref(false)
    let offset = ref(0)
    let eofResult = ref(false)
    let countPosts = ref(0)
    let isLoading = ref(false)
    let noPermission = ref(false)
    let scroll = () => {
      isLoading.value = true
      offset.value += 18

      onLoadMore(offset.value)
    }
    let params = {
      search: "",
      enable: true,
    }

    function onRender(payload) {
      eofResult.value = payload["oef_items"] === true
      if (payload["count_items"] > 0) {
        countPosts.value = payload["count_items"];
      }
      clearResult.value = false
      isLoading.value = false
    }

    function onFilter(q) {
      clearResult.value = true
      offset.value = 0
      eofResult.value = false
      countPosts.value = 0

      q = Helper.mergeObject(q, {
        "limit": 18,
        "offset": offset.value,
        "coupon_is_cancel": true,
      })

      q = Helper.clone(q)

      query.value = q
    }

    function onLoadMore(offset) {
      if (Helper.isEmptyObject(query.value)) {
        return false
      }

      let q = Helper.clone(query.value)

      query.value = Helper.mergeObject(q, {
        "offset": offset,
      })
    }

    const handleScroll = () => {
      if (eofResult.value) return

      let element = scrollComponent.value

      if (!isLoading.value && element.getBoundingClientRect().bottom < window.innerHeight) {
        scroll()
      }
    }

    onMounted(() => {
      if (!checkPermission()) {
        return
      }

      loadCounted()

      window.addEventListener("scroll", handleScroll)
    })

    onUnmounted(() => {
      window.removeEventListener("scroll", handleScroll)
    })

    function loadCounted() {
      Api.statistic().then((resp) => {
        let data = resp.data.data

        counted.newCnt = data["coupon_not_parsed"]
        counted.deleteCnt = data["coupon_delst"]
      })
    }

    function checkPermission() {
    // Раскомментить при добавлении реальных доступов
    // if (!Permission.hasPermissions("admin_promocodes")) {
    // Удалить при добавлении реальных доступов
      if (Permission.hasPermissions("admin_promocodes")) {
        setNoPermission()
        return false
      }

      return true
    }

    function setNoPermission() {
      noPermission.value = true
    }

    function isForbiddenPage() {
      return noPermission.value
    }

    function getParams() {
      return params
    }

    function getQuery() {
      return query.value
    }

    function getClearResult() {
      return clearResult.value
    }

    return {
      counted,
      getParams,
      getQuery,
      getClearResult,
      onRender,
      onFilter,
      scrollComponent,
      isForbiddenPage,
    }
  }
})
</script>
